import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  error,
  success,
} from "../../../../../components/alertMessagesHandler/alert";
import CButton from "../../../../../components/buttons/Button";
import CDropdownSingleSelect from "../../../../../components/dropdown/dropdownSingleSelect";
import CCheckbox from "../../../../../components/inputBoxes/checkbox";
import CRadiobutton from "../../../../../components/inputBoxes/radioButton";
import { LoadingContext } from "../../../../../context/loadingContext";
import {
  SignUpContentHooks,
  SignUpContentUpdateHooks,
} from "../../hooks/useSignup";

const RegContentQuality = (props) => {
  const { setLoading } = useContext(LoadingContext);
  const { portal_id } = useParams();
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const ContentReducer = useSelector((state) => state.BusinessContentReducer);
  const BasicReducer = useSelector((state) => state.BusinessBasicReducer);
  const StatsReducer = useSelector((state) => state.BusinessStatsReducer);
  const ThemeReducer = useSelector((state) => state.BusinessThemeReducer);
  const SocailMediaReducer = useSelector(
    (state) => state.BusinessSocailMediaReducer
  );
  const [FieldsValue, setFieldsValue] = useState();
  const [linkOption, setLinkOption] = useState(false);

  useEffect(() => {
    setButtonAutoPopulate();
  }, [props]);

  const setButtonAutoPopulate = () => {
    switch (
      props.AutoFillDataProp.data_portal_infos &&
      props.AutoFillDataProp.data_portal_infos[0].data_pub_contents[0]
        ? props.AutoFillDataProp.data_portal_infos[0].data_pub_contents[0][
            "post_tag"
          ]
        : ""
    ) {
      case 1:
        document.getElementById(1).checked = true;
        break;
      case 2:
        document.getElementById(2).checked = true;
        break;
      case 3:
        document.getElementById(3).checked = true;
        break;
      case 4:
        document.getElementById(4).checked = true;
        break;
    }

    switch (
      props.AutoFillDataProp.data_portal_infos &&
      props.AutoFillDataProp.data_portal_infos[0].data_pub_contents[0]
        ? props.AutoFillDataProp.data_portal_infos[0].data_pub_contents[0][
            "image_count"
          ]
        : ""
    ) {
      case "No":
        document.getElementById("no").checked = true;
        break;
      case "One":
        document.getElementById("one").checked = true;
        break;
      case "Upto 3":
        document.getElementById("upto3").checked = true;
        break;
      case "More than 3":
        document.getElementById("more3").checked = true;
        break;
    }

    switch (
      props.AutoFillDataProp.data_portal_infos &&
      props.AutoFillDataProp.data_portal_infos[0].data_pub_contents[0]
        ? props.AutoFillDataProp.data_portal_infos[0].data_pub_contents[0][
            "number_of_links"
          ]
        : ""
    ) {
      case "one":
        document.getElementById("one").checked = true;
        break;
      case "two":
        document.getElementById("two").checked = true;
        break;
      case "three":
        document.getElementById("three").checked = true;
        break;
    }
    switch (
      props.AutoFillDataProp.data_portal_infos &&
      props.AutoFillDataProp.data_portal_infos[0].data_pub_contents[0]
        ? props.AutoFillDataProp.data_portal_infos[0].data_pub_contents[0][
            "accept_link"
          ]
        : ""
    ) {
      case 1:
        document.getElementById(5).checked = true;
        break;
      case 0:
        document.getElementById(6).checked = true;
        break;
    }

    if (
      props.AutoFillDataProp.data_portal_infos &&
      props.AutoFillDataProp.data_portal_infos[0].data_pub_contents[0] &&
      props.AutoFillDataProp.data_portal_infos[0].data_pub_contents[0][
        "doFollow"
      ] === 1
    ) {
      setLinkOption(true);
      document.getElementById("dofollow").checked = true;
    }

    // if (
    //   props.AutoFillDataProp.data_portal_infos &&
    //   props.AutoFillDataProp.data_portal_infos[0].data_pub_contents[0] &&
    //   props.AutoFillDataProp.data_portal_infos[0].data_pub_contents[0][
    //     "sponsored_link"
    //   ] === 1
    // ) {
    //   document.getElementById("sponsored_link").checked = true;
    // }
  };

  // Content quality data register in registration page using SignUpContentHooks

  const contentPageHandle = async () => {
    setLoading(true);
    const res = await SignUpContentHooks(FieldsValue);
    setLoading(false);
    if (res.status === 200) {
      dispatch({ type: "BUSINESS_CONTENT_DONE" });
      if (
        props.addnewpage === "add-new-business" ||
        props.addnewpage === "update-new-business"
      ) {
        success("Business Created successfully, Soon it will be approved");
        navigate("/dashboard");
      } else navigate("/registration/congratz");
    } else {
      error(res.message);
    }
  };

  // Update content quality page data using SignUpContentUpdateHooks

  const contentPageUpdateHandle = async () => {
    setLoading(true);
    const data = {
      mpi_id: Number(portal_id),
      updateData: FieldsValue,
    };
    const res = await SignUpContentUpdateHooks(data);
    setLoading(false);
    if (res.status === 200) {
      success("Business Updated successfully");
      navigate("/dashboard");
    } else {
      error(res.message);
    }
  };

  const HandleFieldsValue = (key, value) => {
    setFieldsValue({ ...FieldsValue, [key]: value });
  };

  const submit = (event) => {
    event.preventDefault();
    if (props.regPage === "update-new-business") contentPageUpdateHandle();
    // else if (
    //   BasicReducer === 0 ||
    //   ThemeReducer === 0 ||
    //   StatsReducer === 0 ||
    //   SocailMediaReducer === 0
    // )
    //   error(
    //     "Please fill all mandatory fields in all steps before complete registration"
    //   );
    else if (ContentReducer === 0) contentPageHandle();
    else navigate("/registration/congratz");
  };

  return (
    <>
      <div className="container">
        <div className="row mb-4">
          <div className="col-md-3 col-sm-12"></div>
          <div className="col-md-5 col-sm-12">
            <form onSubmit={submit}>
              <CRadiobutton
                isInline={true}
                required={true}
                labelName={"Do you agree to tag articles as no-follow?"}
                name={"post_tag"}
                faIcon={faInfoCircle}
                faClass={"ms-2 text-primary"}
                faTitle={
                  "A nofollow link is a link that passes the link juice of the origin site to the destination site."
                }
                customClassDiv={"mb-4 text-dark"}
                choiceListArray={[
                  {
                    id: 1,
                    value: 1,
                    label: "Yes",
                  },
                  {
                    id: 2,
                    value: 2,
                    label: "No",
                  },
                ]}
                customClassLabel={"mb-3"}
                functionName={(name, post_tag) =>
                  HandleFieldsValue(name, post_tag)
                }
              />
              <CRadiobutton
                required={true}
                labelName={
                  "Do you accept images or infographics in your content?"
                }
                name={"image_count"}
                customClassDiv={"mb-4 text-dark"}
                isInline={true}
                choiceListArray={[
                  { id: "no", value: "No", label: "No" },
                  { id: "one", value: "One", label: "One" },
                  { id: "upto3", value: "Upto 3", label: "Upto 3" },
                  { id: "more3", value: "More than 3", label: "More than 3" },
                ]}
                customClassLabel={"mb-3"}
                functionName={(name, image_content) => {
                  if (image_content === "No") {
                    HandleFieldsValue("Images_allowed", 0);
                    HandleFieldsValue(name, image_content);
                  } else {
                    HandleFieldsValue("Images_allowed", 1);
                    HandleFieldsValue(name, image_content);
                  }
                }}
              />
              <CDropdownSingleSelect
                required={true}
                labelName={
                  "What is your required word count for the guest post?"
                }
                name={"article_length"}
                placeholder={"Choose Length"}
                customClassLabel={"mb-3"}
                customClassDiv={"text-dark mb-4"}
                customClassSelect={"bg-primary-soft text-muted w-75"}
                defaultValue={
                  props.AutoFillDataProp.data_portal_infos &&
                  props.AutoFillDataProp.data_portal_infos[0]
                    .data_pub_contents[0]
                    ? props.AutoFillDataProp.data_portal_infos[0]
                        .data_pub_contents[0]["article_length"]
                    : ""
                }
                choiceListArray={[
                  { id: "len-0", value: "Below 1000", label: "Below 1000" },
                  { id: "len-1", value: "1000-5000", label: "1000-5000" },
                  { id: "len-2", value: "5000-10000", label: "5000-10000" },
                  { id: "len-3", value: "Above 10000", label: "Above 10000" },
                ]}
                functionName={(name, article_length) =>
                  HandleFieldsValue(name, article_length)
                }
              />
              <CDropdownSingleSelect
                required={true}
                labelName={"Where will the guest post be published?"}
                name={"display_pages"}
                placeholder={"Choose Page"}
                customClassLabel={"mb-3"}
                customClassDiv={"text-dark mb-4"}
                customClassSelect={"bg-primary-soft text-muted w-75"}
                defaultValue={
                  props.AutoFillDataProp.data_portal_infos &&
                  props.AutoFillDataProp.data_portal_infos[0]
                    .data_pub_contents[0]
                    ? props.AutoFillDataProp.data_portal_infos[0]
                        .data_pub_contents[0]["display_pages"]
                    : ""
                }
                choiceListArray={[
                  { id: "home", value: "home_page", label: "Home Page" },
                  {
                    id: "category",
                    value: "category_page",
                    label: "Category Page",
                  },
                  { id: "other", value: "other", label: "Other" },
                ]}
                functionName={(name, page) => HandleFieldsValue(name, page)}
              />
              <CDropdownSingleSelect
                labelName={"How long will you list the guest post?"}
                name={"no_of_days"}
                placeholder={"Choose a value"}
                customClassLabel={"mb-3"}
                customClassDiv={"text-dark mb-4"}
                customClassSelect={"bg-primary-soft text-muted w-75"}
                defaultValue={
                  props.AutoFillDataProp.data_portal_infos &&
                  props.AutoFillDataProp.data_portal_infos[0]
                    .data_pub_contents[0]
                    ? props.AutoFillDataProp.data_portal_infos[0]
                        .data_pub_contents[0]["no_of_days"]
                    : ""
                }
                choiceListArray={[
                  {
                    id: "indefinitely",
                    value: "Indefinitely",
                    label: "Indefinitely",
                  },
                  {
                    id: "12mnth",
                    value: "12 months",
                    label: "12 months",
                  },
                  { id: "24mnth", value: "24 months", label: "24 months" },
                ]}
                functionName={(name, no_of_days) =>
                  HandleFieldsValue(name, no_of_days)
                }
              />

              <CRadiobutton
                isInline={true}
                labelName={
                  "How many do-follow links do you accept per guest post?"
                }
                name={"number_of_links"}
                faIcon={faInfoCircle}
                faClass={"ms-2 text-primary"}
                faTitle={"We recommend to choose 1 or 2."}
                customClassDiv={"mb-4 text-dark"}
                choiceListArray={[
                  {
                    id: "one",
                    value: "one",
                    label: "1",
                  },
                  {
                    id: "two",
                    value: "two",
                    label: "2",
                  },
                  {
                    id: "three",
                    value: "three",
                    label: "3 or more",
                  },
                ]}
                customClassLabel={"mb-3"}
                functionName={(name, number_of_links) =>
                  HandleFieldsValue(name, number_of_links)
                }
              />
              {/* <CTextField
                labelName={
                  "What are the type of link rel attributes do you offer?"
                }
                name={"type_of_link"}
                value={
                  props.AutoFillDataProp.data_portal_infos &&
                  props.AutoFillDataProp.data_portal_infos[0]
                    .data_pub_contents[0]
                    ? props.AutoFillDataProp.data_portal_infos[0]
                        .data_pub_contents[0]["type_of_link"]
                    : ""
                }
                customClassLabel={"mb-3"}
                customClassDiv={"mb-4 text-dark"}
                customClassInput={"bg-primary-soft w-75"}
                functionName={(name, type_of_link) =>
                  HandleFieldsValue(name, type_of_link)
                }
              /> */}
              <CRadiobutton
                isInline={true}
                labelName={"Do you accept link insertion in existing articles?"}
                name={"accept_link"}
                customClassDiv={"mb-2 text-dark"}
                choiceListArray={[
                  {
                    id: 5,
                    value: 1,
                    label: "Yes",
                  },
                  {
                    id: 6,
                    value: 0,
                    label: "No",
                  },
                ]}
                customClassLabel={"mb-3"}
                functionName={(name, accept_link) => {
                  parseInt(accept_link) === 1
                    ? setLinkOption(true)
                    : setLinkOption(false);
                  HandleFieldsValue(name, accept_link);
                }}
              />
              {linkOption ||
              (props.AutoFillDataProp.data_portal_infos &&
                props.AutoFillDataProp.data_portal_infos[0]
                  .data_pub_contents[0] &&
                props.AutoFillDataProp.data_portal_infos[0]
                  .data_pub_contents[0]["doFollow"] === 1) ? (
                <>
                  {" "}
                  <CCheckbox
                    name={"doFollow"}
                    customClassInputDiv={"text-dark"}
                    customClassLabel={"text-primary-new"}
                    choiceListArray={[
                      { id: "dofollow", value: 1, label: "Do Follow" },
                    ]}
                    functionName={(name, doFollow) => {
                      doFollow === []
                        ? HandleFieldsValue(name, 0)
                        : HandleFieldsValue(name, 1);
                    }}
                  />
                  {/* <CCheckbox
                    name={"sponsored_link"}
                    customClassDiv={"mb-5"}
                    customClassInputDiv={"text-dark"}
                    customClassLabel={"text-primary-new"}
                    choiceListArray={[
                      {
                        id: "sponsored_link",
                        value: 1,
                        label: "Sponsored Link",
                      },
                    ]}
                    functionName={(name, sponsored_link) =>
                      HandleFieldsValue(name, sponsored_link)
                    }
                  /> */}
                </>
              ) : (
                <></>
              )}

              <CButton
                btnClassesDiv={"text-center mb-4"}
                btnClasses={"btn px-4 fw-bold text-white"}
                IsOutline={false}
                innertext={"Submit"}
                btnCustomStyle={{
                  backgroundColor: "#044389",
                }}
              />
            </form>
          </div>
          <div className="col-md-4 col-sm-12"></div>
        </div>
      </div>
    </>
  );
};

export default RegContentQuality;
